<template>
  <el-card style="text-align: left; position: relative;" :body-style="{ padding: '0px' }">
    <div class="title">
      <span>{{ title }}</span>
    </div>
    <img :src="avatar" class="image" />
    <div style="padding: 14px;">
      <div class="text item">授课老师：{{ teacher_name }}</div>
      <div class="description item">{{ cardContent }}</div>
      <el-dropdown trigger="click" class="action-button" @command="handleCommand">
        <el-button type="text" icon="el-icon-more"></el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="manage">编辑</el-dropdown-item>
          <el-dropdown-item command="delete">删除</el-dropdown-item>
          <el-dropdown-item command="enter">进入</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </el-card>
</template>

<script>
import { truncate } from "lodash";

export default {
  name: "ClassroomCard",
  data() {
    return {
      editDialogVisible: false
    };
  },
  computed: {
    cardContent: function() {
      return truncate(this.description, {
        length: 100,
      })
    }
  },
  props: {
    title: String,
    teacher_name: String,
    description: String,
    classroom_id: String,
    avatar: String
  },
  methods: {
    handleCommand(command) {
      if (command === "manage") {
        this.editDialogVisible = true;
      }
      if (command === "enter") {
        this.$router.push("/class/" + this.classroom_id);
      }
    }
  }
};
</script>

<style scoped>
.image {
  width: 100%;
  display: block;
}
.title {
  color: white;
  position: absolute;
  padding: 16px 16px;
  font-size: 20px;
  font-weight: 600;
  width: calc(100% - 32px);
  z-index: 10;
}
.text {
  font-size: 14px;
}
.description {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.65);
}
.action-button {
  float: right;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
</style>